import React from 'react';
import PropTypes from 'prop-types';

import ContactInfo from './contact_info';
import Email from './email';
import ManagedFormGroup from 'components/form/managed_input/form_group';

export default class CompanyForm extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      additionalEmails: PropTypes.array.isRequired,
      addresses: PropTypes.array.isRequired,
      email: PropTypes.string,
      name: PropTypes.string,
      phoneNumbers: PropTypes.array.isRequired,
      website: PropTypes.string
    }),
    extraSections: PropTypes.node,
    onChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="d-flex flex-column gap-6">
        {this.renderCompanyInfo()}
        {this.renderContactInfo()}
        {this.props.extraSections}
      </div>
    );
  }

  renderCompanyInfo() {
    return <div className="form-vertical-field-container">
      <h6>Company & website</h6>
      {this.renderFormGroup('name', 'Company name', { placeholder: 'Type company name', required: true })}
      {this.renderFormGroup('website', 'Company website', { placeholder: 'Type company website' })}
    </div>;
  }

  renderContactInfo() {
    return <div className="form-vertical-field-container">
      <h6>Contact information</h6>

      <Email
        contact={this.props.contact}
        onChange={this.props.onChange}
      />

      <ContactInfo
        addresses={this.props.contact.addresses}
        phoneNumberLabels={['Main', 'Fax']}
        phoneNumbers={this.props.contact.phoneNumbers}
        onChange={this.props.onChange}
      />
    </div>;
  }

  renderFormGroup(name, label, props = {}) {
    return (
      <ManagedFormGroup
        autoComplete="off"
        label={label}
        name={name}
        value={this.props.contact[name]}
        onChange={this.props.onChange}
        {...props}
      />
    );
  }
}
